var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav',{attrs:{"header":_vm.header}}),_c('Leilao',{attrs:{"configuracao":_vm.baseConfigLeilao}}),_c('Footer',{attrs:{"texto":_vm.rodape,"screen":"eletronico"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }